// DualSlider.js
import React from "react";
import { Range, getTrackBackground } from "react-range";
import { Label } from "../ui/label";

const MIN = 0;
const MAX = 100;
const STEP = 1;

function DualSlider({ values, onChange }) {
  return (
    <div className="w-full px-2 sm:px-0">
      <Label className="mb-2 text-sm sm:text-base">Profit Split (%)</Label>

      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        onChange={onChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="h-2 sm:h-2.5 w-full rounded bg-gray-200"
            style={{
              background: getTrackBackground({
                values,
                colors: ["#10b981", "#c96442", "#9ca3af"],
                min: MIN,
                max: MAX,
              }),
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props, index }) => (
          <div
            {...props}
            className="h-5 w-5 sm:h-6 sm:w-6 rounded-full bg-amber-500 border-2 border-white shadow-md touch-manipulation focus:outline-none focus:ring-2 focus:ring-amber-400"
            style={{
              ...props.style,
            }}
          />
        )}
      />

      <div className="flex justify-between mt-2 text-xs sm:text-sm text-gray-600 px-1">
        <span>0%</span>
        <span className="text-center">
          <span className="font-medium">{values[0]}%</span>
          <span className="mx-1">-</span>
          <span className="font-medium">{values[1]}%</span>
        </span>
        <span>100%</span>
      </div>
    </div>
  );
}

export default DualSlider;
